/*
 * hyperion-index:begin
 * ---
 * path: hyperion-cloud/web/src/platform/design-system/hooks/useTheme.ts
 * layer: web
 * area: hooks
 * kind: hook
 * web_root: hooks
 * relpath: web/src/platform/design-system/hooks/useTheme.ts
 * filename: useTheme.ts
 * extension: ts
 * ---
 * hyperion-index:end
 */

import { useContext } from 'react';
import { ThemeContext } from '@/platform/design-system/providers/ThemeProvider';

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}
